<template>
  <div v-bind:class="{ 'dark-mode': darkTheme }">
    <transition name="show">
      <div
        class="nav-side-menu h-100"
        v-bind:class="{
          'cursor-pointer': minimized,
        }"

      >
      <!-- @click="minimized ? toogleMinimize(false) : ''"
        @mouseover="minimized ? hoverMinimize(false) : null"
        @mouseleave="minimized ? hoverMinimize(true) : null"       -->
        <vue-progress-bar></vue-progress-bar>
        <div class="top-container" >
          <div class="no-drag item text-center">
            <div class="not-side-button mb-2">
              <template v-if="showUploadLogo">
                <router-link to="/website/settings">
                  <div
                    class="
                      position-absolute
                      text-muted2
                      a-link
                      ml-2
                      cursor-pointer
                    "
                    style="font-size: 11px"
                  >
                    <font-awesome-icon icon="long-arrow-alt-down" />
                    {{ t('Upload your logo') }}
                  </div>
                </router-link>
              </template>
              <router-link to="/" class="ml-2">
                <img
                  v-if="!minimized"
                  height="auto"
                  width="120px"
                  style="background-color: transparent; border: none"
                  class="ml-2 py-3 pb-4"
                  v-bind:class="{ 'mt-2': showUploadLogo }"
                  :src="
                    darkTheme
                      ? 'https://uploads-ssl.webflow.com/62679692b1466017b8eae590/62679efdb270f93c71a075f7_bw-logo.svg'
                      : $customdomain().logo
                  "
                />
              </router-link>
              <!-- <div
                class="position-absolute btn"
                style="right: 10px; top: 19px"
                @click="toogleMinimize(true)"
                v-if="!minimized"
              >
                <font-awesome-icon icon="chevron-left" class="text-muted" />
              </div>
              <div
                class="position-absolute btn"
                style="right: 10px; top: 19px"
                @click="toogleMinimize(false)"
                v-if="minimized"
              >
                <font-awesome-icon icon="chevron-right" class="text-muted" />
              </div>               -->
            </div>
          </div>
          <div
            v-if="[0, 4, 101, 102, 103, 105, 201, 202, 203].includes(Number($session.get('paid_plan'))) && !$isWhitelabel()"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Overview' }"
          >
            <router-link
              to="/overview"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <!-- <font-awesome-icon class="fa-md mx-3 my-auto" icon="home" /> -->
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="home" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Overview') }}
              </template>
            </router-link>
          </div>
          <div
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Dashboard' }"
          >
            <router-link
              to="/dashboard"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" :icon="['fas', 'tachometer-alt']" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Dashboard') }}
              </template>
            </router-link>
          </div>

          <div class="sidebar-header">VISUALIZE</div>
          <div
            v-if="recordVal"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Recordings' }"
          >
            <router-link
              @click.native="trackCategory('recordings')"
              to="/recordings"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <!-- <font-awesome-icon class="fa-md mx-3 my-auto" icon="video" /> -->
              <svg class="fa-md mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(4,4)"><path d="M5,11v42h54v-42zM13,50h-4v-4h4zM13,42h-4v-4h4zM13,34h-4v-4h4zM13,26h-4v-4h4zM13,18h-4v-4h4zM26,43v-20l16.857,10zM55,50h-4v-4h4zM55,42h-4v-4h4zM55,34h-4v-4h4zM55,26h-4v-4h4zM55,18h-4v-4h4z"></path></g></g></svg>
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Recordings') }}
              </template>
            </router-link>
          </div>   

          <div
            v-if="heatmapVal"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name.includes('Heatmap') }"
          >
            <router-link
              @click.native="trackCategory('continuous_heatmap')"
              to="/heatmap/continuous"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <!-- <font-awesome-icon class="fa-md mx-3 my-auto" icon="fire" /> -->
              <svg class="fa-md mx-3 my-auto"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(4,4)"><path d="M45,13c0,0 -2,8 -7,8c-11,0 -7,-18 -7,-18c0,0 -10,6 -13,22c-4,-2 -5,-8 -5,-8c0,0 -6,7 -6,18c0,21 20,23 20,23c0,0 -5,-6 -5,-13c0,-11 4.696,-16 4.696,-16c0,0 1,11 7.304,11c4,0 6,-3 6,-3c0,0 4,4 4,11c0,6.348 -5,10 -5,10c10.478,-2.106 18,-11.79 18,-22.862c0,-13.138 -12,-22.138 -12,-22.138z"></path></g></g></svg>
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Heatmaps') }}
              </template>
            </router-link>
          </div>   

          <!-- <div
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'ChatGPT' }"
          >
            <router-link
              to="/chat"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="robot" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('ChatGPT') }}
              </template>
            </router-link>
          </div>        -->

          <div class="sidebar-header">INSIGHT</div>

          <!-- && ($isFeatureEnabled('deprecated-feature') || isLocalhost) -->
          <div
            v-if="analyticsVal"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Analytics' }"
          >
            <router-link
              to="/analytics"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="chart-line" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Traffics') }}
              </template>
            </router-link>
          </div>     
          
          <div
            v-if="eventtrackVal"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Events' }"
          >
            <router-link
              @click.native="trackCategory('events')"
              to="/events"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
            <svg class="fa-md mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(10.24,10.24)"><path d="M9.7,11.3l2.4,11.1c0.1,0.5 0.6,0.9 1.1,1c0.5,0.1 1.1,-0.2 1.4,-0.7l1.4,-2.6l3.9,3.9c0.5,0.5 1.4,0.5 1.9,0l2.4,-2.4c0.5,-0.5 0.5,-1.4 0,-1.9l-4,-3.7l2.5,-1.4c0.5,-0.3 0.8,-0.8 0.7,-1.4c-0.1,-0.6 -0.5,-1 -1,-1.1l-11.1,-2.3c-0.9,-0.2 -1.8,0.7 -1.6,1.5zM11,5.6c0.6,0 1,-0.5 1,-1v-3c0,-0.6 -0.5,-1 -1,-1c-0.6,0 -1,0.5 -1,1v3c0,0.5 0.4,1 1,1zM7.3,5.7l-2.2,-2.1c-0.4,-0.5 -1.1,-0.5 -1.5,0c-0.4,0.4 -0.4,1 0,1.4l2.1,2.1c0.4,0.4 1.1,0.4 1.5,0c0.5,-0.3 0.5,-1 0.1,-1.4zM0.6,10.9c0,0.6 0.5,1 1,1h3c0.6,0 1,-0.5 1,-1c0,-0.5 -0.5,-1 -1,-1h-3c-0.6,0 -1,0.5 -1,1zM5.8,14.7l-2.1,2.1c-0.4,0.4 -0.4,1.1 0,1.5c0.4,0.4 1.1,0.4 1.5,0l2.1,-2.1c0.4,-0.4 0.4,-1.1 0,-1.5c-0.5,-0.4 -1.1,-0.4 -1.5,0zM16.3,7.2l2.1,-2.2c0.4,-0.4 0.4,-1.1 0,-1.5c-0.4,-0.4 -1.1,-0.4 -1.5,0l-2.1,2.1c-0.4,0.4 -0.4,1.1 0,1.5c0.4,0.5 1.1,0.5 1.5,0.1z"></path></g></g></svg>
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Events') }}
              </template>
            </router-link>
          </div>               

          <!-- <div v-if="recordVal || heatmapVal || eventtrackVal">
            <div
              class="no-drag item category-title2"
              @click="toogleMenu('behavior')"
            >
              <span class="nav-link cursor-pointer btn-noshadow side-button">
                <font-awesome-icon
                  class="mx-3"
                  style="margin-left: 1.3rem"
                  icon="mouse-pointer"
                />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Behavior') }}
                  <font-awesome-icon
                    class="float-right fa-xs"
                    style="margin-top: 4px"
                    icon="chevron-up"
                    v-if="displayMenu.includes('behavior')"
                  />
                  <font-awesome-icon
                    class="float-right fa-xs"
                    style="margin-top: 4px"
                    icon="chevron-down"
                    v-else
                  />
                </template>
              </span>
            </div>
            <transition name="slideDown">
              <div
                class="menu-wrapper"
                v-show="displayMenu.includes('behavior') && !minimized"
              >
                <div
                  v-if="recordVal"
                  class="no-drag item"
                  :class="{ activebg: $route.name == 'Recordings' }"
                >
                  <router-link
                    @click.native="trackCategory('recordings')"
                    to="/recordings"
                    class="
                      nav-link
                      cursor-pointer
                      btn-noshadow
                      side-button
                      menu-indent
                    "
                  >
                    {{ t('Recordings') }}
                  </router-link>
                </div>

                <div
                  v-if="heatmapVal"
                  class="no-drag item"
                  :class="{
                    activebg: $route.name.includes('Heatmap'),
                  }"
                >
                  <router-link
                    v-if="heatmapOldVersion()"
                    to="/heatmap"
                    @click.native="trackCategory('heatmap')"
                    class="
                      nav-link
                      cursor-pointer
                      btn-noshadow
                      side-button
                      menu-indent
                    "
                  >
                    {{ t('Heatmaps') }}
                  </router-link>
                  <router-link
                    v-else
                    to="/heatmap/continuous"
                    @click.native="trackCategory('continuous_heatmap')"
                    class="
                      nav-link
                      cursor-pointer
                      btn-noshadow
                      side-button
                      menu-indent
                    "
                  >
                    {{ t('Heatmaps') }}
                  </router-link>
                </div>

                <div
                  v-if="eventtrackVal"
                  class="no-drag item"
                  :class="{ activebg: $route.name == 'Events' }"
                >
                  <router-link
                    to="/events"
                    @click.native="trackCategory('events')"
                    class="
                      nav-link
                      cursor-pointer
                      btn-noshadow
                      side-button
                      menu-indent
                    "
                  >
                    {{ t('Events') }}
                  </router-link>
                </div>
              </div>
            </transition>
          </div> -->

          <!-- <div v-if="abtestVal || personalizeVal">
            <div
              class="no-drag item category-title2"
              @click="toogleMenu('experiment')"
            >
              <span class="nav-link cursor-pointer btn-noshadow side-button">
                <font-awesome-icon class="fa-md mx-3 my-auto" icon="flask" />
                <template v-if="!minimized || showDuringMinimize">
                  {{ t('Experiment') }}
                  <font-awesome-icon
                    class="float-right fa-xs"
                    style="margin-top: 4px"
                    icon="chevron-up"
                    v-if="displayMenu.includes('experiment')"
                  />
                  <font-awesome-icon
                    class="float-right fa-xs"
                    style="margin-top: 4px"
                    icon="chevron-down"
                    v-else
                  />
                </template>
              </span>
            </div>
            <transition name="slideDown">
              <div
                class="menu-wrapper"
                v-show="displayMenu.includes('experiment') && !minimized"
              >
                <div
                  v-if="abtestVal"
                  class="no-drag item"
                  :class="{
                    activebg:
                      $route.name == 'A/B Split Test' ||
                      $route.name == 'A/B Result',
                  }"
                >
                  <router-link
                    to="/ab-test"
                    @click.native="trackCategory('ab_testing')"
                    class="
                      nav-link
                      cursor-pointer
                      btn-noshadow
                      side-button
                      menu-indent
                    "
                  >
                    {{ t('A/B Testing') }}
                  </router-link>
                </div>

                <div
                  v-if="personalizeVal"
                  class="no-drag item"
                  :class="{
                    activebg:
                      $route.name == 'Personalized Experience' ||
                      $route.name == 'Personalized Experience Result',
                  }"
                >
                  <router-link
                    to="/personalize"
                    @click.native="trackCategory('personalization')"
                    class="
                      nav-link
                      cursor-pointer
                      btn-noshadow
                      side-button
                      menu-indent
                    "
                  >
                    {{ t('Personalization') }}
                  </router-link>
                </div>
              </div>
            </transition>
          </div> -->
  
          <div
            v-if="funnelVal"
            @click.native="trackCategory('funnel')"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Funnel' }"
          >
            <router-link
              to="/funnel"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="filter" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Funnels') }}
              </template>
            </router-link>
          </div> 

          <div
            v-if="formAnalyticVal"
            @click.native="trackCategory('form')"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name.includes('Form') }"
          >
            <router-link
              to="/form"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <!-- <font-awesome-icon class="fa-md mx-3 my-auto" icon="comment" /> -->
              <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M45,4h-40c-0.55,0 -1,0.45 -1,1v40c0,0.55 0.45,1 1,1h40c0.55,0 1,-0.45 1,-1v-40c0,-0.55 -0.45,-1 -1,-1zM21,12h18v6h-18zM21,24h18v6h-18zM18,28h-8v-2h8zM18,16h-8v-2h8zM25,40h-4v-4h4zM40,39h-12v-2h12z"></path></g></g></svg>
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Form Analytics') }}
              </template>
            </router-link>
          </div>                 
          
          <!-- <div
            @click.native="trackCategory('goals')"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name.includes('Goal') }"
          >
            <router-link
              to="/goals"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="bullseye" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Goals') }}
              </template>
            </router-link>
          </div> -->

          <div v-if="!isShopify && (feedbackVal || surveyVal)" class="sidebar-header">OPINION</div>

          <div
            v-if="surveyVal"
            @click.native="trackCategory('survey')"
            class="no-drag item category-title2"
            :class="{  activebg: $route.name == 'Polls' || $route.name === 'ViewPolls' }"
          >
            <router-link
              to="/survey"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(5.12,5.12)"><path d="M25,0c-1.84766,0 -3.35937,1.28906 -3.8125,3h-12.1875c-1.65234,0 -3,1.34766 -3,3v39c0,1.65234 1.34766,3 3,3h32c1.65234,0 3,-1.34766 3,-3v-39c0,-1.65234 -1.34766,-3 -3,-3h-7.9375c-0.01953,0 -0.04297,0 -0.0625,0h-4.1875c-0.45312,-1.71094 -1.96484,-3 -3.8125,-3zM25,2c1.11719,0 2,0.88281 2,2c0,0.55078 0.44922,1 1,1h4v3h-14v-3h4c0.55078,0 1,-0.44922 1,-1c0,-1.11719 0.88281,-2 2,-2zM29,17c0.25391,0 0.52344,0.08594 0.71875,0.28125l2.28125,2.3125l2.28125,-2.3125c0.39063,-0.39062 1.04688,-0.39062 1.4375,0c0.39063,0.39063 0.39063,1.04688 0,1.4375l-2.3125,2.28125l2.3125,2.28125c0.39063,0.39063 0.39063,1.04688 0,1.4375c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125l-2.28125,-2.3125l-2.28125,2.3125c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375l2.3125,-2.28125l-2.3125,-2.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375c0.19531,-0.19531 0.46484,-0.28125 0.71875,-0.28125zM14,20h10c0.55469,0 1,0.44922 1,1c0,0.55078 -0.44531,1 -1,1h-10c-0.55469,0 -1,-0.44922 -1,-1c0,-0.55078 0.44531,-1 1,-1zM29,30c0.25391,0 0.52344,0.08594 0.71875,0.28125l2.28125,2.3125l2.28125,-2.3125c0.39063,-0.39062 1.04688,-0.39062 1.4375,0c0.39063,0.39063 0.39063,1.04688 0,1.4375l-2.3125,2.28125l2.3125,2.28125c0.39063,0.39063 0.39063,1.04688 0,1.4375c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125l-2.28125,-2.3125l-2.28125,2.3125c-0.19531,0.19531 -0.46094,0.28125 -0.71875,0.28125c-0.25781,0 -0.52344,-0.08594 -0.71875,-0.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375l2.3125,-2.28125l-2.3125,-2.28125c-0.39062,-0.39062 -0.39062,-1.04687 0,-1.4375c0.19531,-0.19531 0.46484,-0.28125 0.71875,-0.28125zM14,33h10c0.55469,0 1,0.44922 1,1c0,0.55078 -0.44531,1 -1,1h-10c-0.55469,0 -1,-0.44922 -1,-1c0,-0.55078 0.44531,-1 1,-1z"></path></g></g></svg>
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Survey & NPS') }}
              </template>
            </router-link>
          </div> 
          
          <div
            v-if="feedbackVal"
            @click.native="trackCategory('feedback')"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Feedback' || $route.name === 'ViewFeedback' }"
          >
            <router-link
              to="/feedback"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <!-- <font-awesome-icon class="fa-md mx-3 my-auto" icon="comment" /> -->
              <svg class="fa-lg mx-3 my-auto" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="currentColor" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g transform="scale(10.66667,10.66667)"><path d="M20,3h-15.989c-1.1,0 -2.001,0.9 -2.001,2l-0.009,11.999c0,1.105 0.895,2.001 2,2.001h1.499c0.276,0 0.5,0.224 0.5,0.5v2.086c0,0.891 1.077,1.337 1.707,0.707l3,-3c0.188,-0.188 0.442,-0.293 0.707,-0.293h8.586c1.1,0 2,-0.9 2,-2v-12c0,-1.1 -0.9,-2 -2,-2zM16.82,9.97l-2.269,1.965l0.682,2.937c0.088,0.38 -0.324,0.68 -0.659,0.478l-2.574,-1.554l-2.574,1.552c-0.335,0.202 -0.747,-0.098 -0.658,-0.479l0.682,-2.928l-2.27,-1.963c-0.295,-0.256 -0.138,-0.741 0.252,-0.775l2.993,-0.256l1.169,-2.764c0.152,-0.359 0.661,-0.36 0.814,0l1.168,2.756l2.994,0.256c0.388,0.034 0.546,0.519 0.25,0.775z"></path></g></g></svg>
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Feedbacks') }}
              </template>
            </router-link>
          </div> 
<!-- 
          <div v-if="(abtestVal || personalizeVal) && $session.get('user_id') < 7385 && $session.get('company_id') > 1000"
            @click.native="trackCategory('experiment')"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name.includes('Experiment') }"
          >
            <router-link
              to="/experiment"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="flask" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Experiments') }}
              </template>
            </router-link>
          </div>          
          
          <div v-if="(abtestVal || personalizeVal) && $session.get('user_id') < 7385 && $session.get('company_id') > 1000"
            @click.native="trackCategory('goal')"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name.includes('Goal') }"
          >
            <router-link
              to="/goals"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="hourglass" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Goal') }}
              </template>
            </router-link>
          </div>            -->
          
          <div v-if="recommendationsVal > 0 && isAdmin"
            class="no-drag item category-title2"
            :class="{ activebg: $route.name == 'Recommendations' }"
          >
            <router-link
              to="/recommendations"
              tag="span"
              class="nav-link cursor-pointer btn-noshadow side-button d-flex flex-row"
              style="padding-right: 0;"
            >
              <font-awesome-icon class="fa-md mx-3 my-auto" icon="lightbulb" />
              <template v-if="!minimized || showDuringMinimize">
                {{ t('Recommendations') }}
                <span v-if="enableRecommendVal === 0" class="badge badge-highlight small fs-9" style="margin-left: 5px;">
                  {{ 'New' }}
                </span>
                <span
                  v-if="totalUnreadRecomm > 0 && enableRecommendVal !== 0"
                  class="badge-notify float-right small fs-9"
                  style="font-size: 12px !important; background-color: #fef6b3; color: #7f4d23; margin-right: 10px;"
                  >{{ totalUnreadRecomm }}
                </span>
              </template>
            </router-link>
          </div>                     
          <!-- <div>
        <div
          @click="toogleMenu('visitor')"
          class="no-drag item category-title2"
          style="border-top: 0px"
        >
          <span class="nav-link cursor-pointer btn-noshadow side-button">
            <font-awesome-icon class="fa-md mx-3 my-auto" icon="user" />
            {{ t('Visitor') }}
            <font-awesome-icon
              class="float-right fa-xs"
              style="margin-top: 4px"
              icon="chevron-up"
              v-if="displayMenu.includes('visitor')"
            />
            <font-awesome-icon
              class="float-right fa-xs"
              style="margin-top: 4px"
              icon="chevron-down"
              v-else
            />
          </span>
        </div>
        <transition name="slideDown">
          <div
            class="menu-wrapper"
            v-show="displayMenu.includes('visitor')  && !minimized"
          >
            <div
              class="no-drag item"
              :class="{
                activebg:
                  $route.name == 'Visitor' || $route.name === 'Visitors',
              }"
            >
              <router-link
                to="/visitor/realtime"
                @click.native="trackCategory('visitor_realtime')"
                class="
                  nav-link
                  cursor-pointer
                  btn-noshadow
                  side-button
                  menu-indent
                "
              >
                {{ t('Real Time') }}
              </router-link>
            </div>

            <div
              class="no-drag item"
              :class="{
                activebg:
                  $route.name == 'Maps' || $route.name === 'VisitorMaps',
              }"
            >
              <router-link
                to="/visitor/map"
                @click.native="trackCategory('visitor_map')"
                class="
                  nav-link
                  cursor-pointer
                  btn-noshadow
                  side-button
                  menu-indent
                "
              >
                {{ t('Maps') }}
              </router-link>
            </div>
            <div
              class="no-drag item"
              :class="{
                activebg:
                  $route.name == 'Retention' ||
                  $route.name === 'VisitorRetention',
              }"
            >
              <router-link
                to="/visitor/retention"
                @click.native="trackCategory('visitor_retention')"
                class="
                  nav-link
                  cursor-pointer
                  btn-noshadow
                  side-button
                  menu-indent
                "
              >
                {{ t('Retention') }}
              </router-link>
            </div>
            <div
              class="no-drag item"
              :class="{
                activebg:
                  $route.name == 'Acquisition' || $route.name === 'AcqChannel',
              }"
            >
              <router-link
                to="/visitor/acquisition"
                class="
                  nav-link
                  cursor-pointer
                  btn-noshadow
                  side-button
                  menu-indent
                "
              >
                {{ t('Acquistion Channel') }}
              </router-link>
            </div>
          </div>
        </transition>
      </div> -->
        </div>

        <template v-if="$session.get('role') !== 3">
          <div
            class="btm-container w-100 p-3 position-fixed bg-white"
            style="left: 0px; max-width: calc(var(--sidebar-width) - 1px);bottom: 0px;"
          >
            <!-- <div class="no-drag item category-title">Free plan</div> -->
            <!-- <div class="no-drag item">
          <router-link
            v-if="$isFreePlan.includes($session.get('paid_plan')) || $isLegacyFreePlan.includes($session.get('paid_plan')) || day2expire"
            tag="button"
            to="/subscription"
            class="btn btn-first btn-primary-outline nav-link cursor-pointer text-center side-button"
          >Upgrade Plan</router-link>
          </div>-->
            <!-- && day2expire < 1000 -->
            <div
              class="bottom-container"
              v-if="!minimized || showDuringMinimize"
            >
              <span class="mr-2 small text-center">
                <div class="item text-left">
                  <p
                    class="
                      category-title
                      mb-0
                      font-weight-bold
                      text-left
                      pl-0
                      pt-2
                      fs-12
                    "
                    v-if="isHowuku"
                  >
                    <template v-if="day2expire < 1000 && day2expire > 0"
                      >Trial</template
                    >
                    <template v-if="day2expire > 1000">Lifetime</template>
                    {{ setAgencyName(plan.plan_name) }} Plan
                  </p>
                  <p
                    class="
                      category-title
                      mb-0
                      font-weight-bold
                      text-left
                      pl-0
                      pt-2
                    "
                    v-else-if="
                      !isHowuku &&
                      $session.get('role') !== 3 &&
                      $session.get('role') !== 2
                    "
                  >
                    <template v-if="day2expire < 1000 && day2expire > 0"
                      >Trial</template
                    >
                    <template v-if="day2expire > 1000">Lifetime</template>
                    {{ setAgencyName(plan.plan_name) }} Plan
                  </p>
                  <!-- <hr class="mt-0 mb-2" /> -->

                  <!-- <div class="row" :key="monthly" v-if="isHowuku">
                    <div class="col-md-7">
                      <p class="mb-1 pt-1 fs-12">Active users</p>
                    </div>
                    <div class="col-md-5 text-right">
                      <p class="mb-1 pt-1 fs-12">
                        {{ availableUsersCounter }}
                      </p>
                    </div>
                  </div> -->

                  <div class="row" :key="monthly" v-if="isHowuku">
                    <div class="col-md-7">
                      <p class="mb-1 pt-1 fs-12" v-if="!isSession">
                        Pageview
                        <span
                          class="tooltip-pop"
                          rel="This is your monthly pageview usage limits."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa fa-sm text-muted"
                          />
                        </span>
                      </p>
                      <p class="mb-1 pt-1 fs-12" v-else>
                        Session
                        <span
                          class="tooltip-pop"
                          rel="This is your monthly session usage limits."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa fa-sm text-muted"
                          />
                        </span>
                      </p>
                    </div>
                    <div class="col-md-5 text-right">
                      <p class="mb-1 pt-1 fs-12">
                        {{ numberToText2(monthly) }}
                        <!-- {{ numberToText(pageviewLimit) }} -->
                      </p>
                    </div>
                  </div>
                  <div
                    class="row"
                    :key="monthly + 1"
                    v-else-if="
                      !isHowuku &&
                      $session.get('role') !== 3 &&
                      $session.get('role') !== 2
                    "
                  >
                    <div class="col-md-5">
                      <p class="mb-1 pt-1 fs-12" v-if="!isSession">
                        Pageview
                        <span
                          class="tooltip-pop"
                          rel="This is your monthly pageview usage limits."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa fa-sm text-muted"
                          />
                        </span>
                      </p>
                      <p class="mb-1 pt-1 fs-12" v-else>
                        Session
                        <span
                          class="tooltip-pop"
                          style="border-bottom: none;"
                          rel="This is your monthly session usage limits."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa fa-sm text-muted"
                          />
                        </span>
                      </p>
                    </div>
                    <div class="col-md-7 text-right">
                      <p class="mb-1 pt-1 fs-12">
                        {{ numberToText2(monthly) }}
                        <!-- {{ numberToText(pageviewLimit) }} -->
                      </p>
                    </div>
                  </div>
                  <!-- <div
                    :key="monthly"
                    class="mb-3 mt-1 progress progress-mini clearfix"
                    style="height: 3px !important"
                    v-if="isHowuku"
                  >
                    <div
                      v-bind:class="{
                        'progress-bar':
                          cap100((monthly / pageviewLimit) * 100) < 90,
                        'progress-warning':
                          cap100((monthly / pageviewLimit) * 100) >= 90,
                      }"
                      role="progressbar"
                      :style="
                        'width: ' +
                        cap100((monthly / pageviewLimit) * 100) +
                        '% !important;'
                      "
                      v-bind:aria-valuenow="
                        cap100((monthly / pageviewLimit) * 100)
                      "
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div
                    :key="monthly + 1"
                    class="mb-3 mt-1 progress progress-mini clearfix"
                    style="height: 3px !important"
                    v-else-if="
                      !isHowuku &&
                      $session.get('role') !== 3 &&
                      $session.get('role') !== 2
                    "
                  >
                    <div
                      v-bind:class="{
                        'progress-bar':
                          cap100((monthly / pageviewLimit) * 100) < 90,
                        'progress-warning':
                          cap100((monthly / pageviewLimit) * 100) >= 90,
                      }"
                      role="progressbar"
                      :style="
                        'width: ' +
                        cap100((monthly / pageviewLimit) * 100) +
                        '% !important;'
                      "
                      v-bind:aria-valuenow="
                        cap100((monthly / pageviewLimit) * 100)
                      "
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div> -->
                  <button
                    v-if="$session.get('whitelabel_ref_id') === 0 && $isHowuku"
                    class="btn btn-block my-2"
                    v-bind:class="{
                      'btn-cta': darkTheme,
                      'btn-third': !darkTheme,
                    }"
                    @click="$router.push({ path: '/checkout' })"
                  >
                  <!-- v-if="day2expire < 10" -->
                    <!-- <span>Upgrade Now 10% OFF</span> -->
                    <span>Upgrade plan</span>
                  </button>
                  <button
                    v-else
                    class="btn btn-block my-2"
                    v-bind:class="{
                      'btn-cta': darkTheme,
                      'btn-third': !darkTheme,
                    }"
                    @click="$router.push({ path: '/newcheckout' })"
                  >
                  <!-- v-if="day2expire < 10" -->
                    <!-- <span>Upgrade Now 10% OFF</span> -->
                    <span>Upgrade plan</span>
                  </button>
                  <p
                    class="mb-1 text-danger fs-14 font-weight-bold"
                    v-if="day2expire > 0 && day2expire < 1000 && day2expire > 0"
                  >
                    Trial expires in {{ day2expire }} days
                  </p>
                  <!-- <p
                class="text-primary cursor-pointer font-weight-bold"
                v-if="
                  $isFreePlan.includes($session.get('paid_plan')) ||
                  ($isLegacyFreePlan.includes($session.get('paid_plan')) &&
                    isHowuku)
                "
                @click="$router.push({ path: '/subscription' })"
              >
                Upgrade Plan
              </p>
              <p
                class="text-primary cursor-pointer font-weight-bold"
                v-else-if="
                  $isFreePlan.includes($session.get('paid_plan')) ||
                  ($isLegacyFreePlan.includes($session.get('paid_plan')) &&
                    !isHowuku &&
                    $session.get('role') !== 3 &&
                    $session.get('role') !== 2)
                "
                @click="$router.push({ path: '/subscription' })"
              >
                Upgrade Plan
              </p> -->
                </div>
              </span>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import { store } from '@/store'

/* eslint-disable */
export default {
  mixins: [clickaway],
  store,
  components: {},
  watch: {
    '$store.getters.widget_id': {
      handler: function () {
        this.loadData()
      },
      deep: true,
    },
    '$store.getters.notifFeedback': {
      handler: function (v) {
        this.notificationCount = v
      },
      deep: true,
    },
  },
  data: function () {
    return {
      promoText: '',
      isEventPromo: false,
      darkTheme: false,
      isSession: false,
      hoverDelay: null,
      minimized: false,
      showDuringMinimize: false,
      displayMenu: [],
      availableUsersCounter: 1,
      notificationCount: 0,
      planTotalLimit: 0,
      monthly: 0,
      feedbackVal: 0,
      surveyVal: 0,
      recordVal: 0,
      heatmapVal: 0,
      eventtrackVal: 0,
      formAnalyticVal: 0,
      abtestVal: 0,
      personalizeVal: 0,
      analyticsVal: 0,
      funnelVal: 0,
      errortrackVal: 0,
      recommendationsVal: 0,
      goalVal: 0,
      widgets: {},
      acl_data: {},
      pageviewLimit: 0,
      contentStatus: '',
      day2expire: null,
      plan: {},
      showUploadLogo: false,
      isHowuku: false,
      isAdmin:
        this.$session.get('role') === 0 || this.$session.get('role') === 1,
      enableRecommendVal: 0,
      totalUnreadRecomm: 0,
      isShopify: false
    }
  },
  beforeCreate() {
    this.$http.get(process.env.API_ENDPOINT + '/plan/info').then((response) => {
      let data = response.data
      this.plan = data[this.$session.get('paid_plan')]
    })
    this.$http.get(process.env.API_ENDPOINT + '/trial').then((response) => {
      let data = response.data
      this.day2expire =
        data[0].days_to_expire > 0 ? data[0].days_to_expire : null
      this.$session.set('day2expire', this.day2expire)
    })
  },
  beforeMount() {
    // this.darkTheme = Number(this.$session.get('company_id')) % 2
    this.darkTheme = true
    if (window.location.host === 'sp.howuku.com') this.isShopify = true

    this.$http.get(process.env.API_ENDPOINT + '/users/active').then((response) => {
      let data = response.data
      this.availableUsersCounter = data.length
    })
    setTimeout(() => {
      this.$http
        .get(process.env.API_ENDPOINT + '/user/attribute/REASON_NO_UPGRADE')
        .then((result) => {})
        .catch((err) => {
          //SHOW
          if (this.day2expire < 6 && this.day2expire > 0)
            this.messages = [
              {
                key: 'REASON_NO_UPGRADE',
                subject: 'Your trial will end in ' + this.day2expire + ' days',
                body: "What's stopping you from upgrading your account today?",
                options: [
                  "I can't justify the price",
                  'Still evaluating',
                  'Need budget approval',
                ],
              },
            ]
        })
    }, 3000)
  },
  mounted() {

    let cachedAclData = window.localStorage.getItem('feature_acl')
    if (cachedAclData) this.setFeaturesACL(cachedAclData)

    this.$http.post(process.env.API_ENDPOINT + '/getUsers').then((response) => {
      let info = response.data[0]
      if (info && info.event_promo) {
        this.isEventPromo = true
        this.promoText = 'TIA 50%'
      }
    })

    this.isLocalhost = window.location.host.includes('localhost')
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost') ||
      window.location.host === 'demo.howuku.com'
    if (!this.isHowuku) this.darkTheme = false // dark theme only for Howuku

    setTimeout(() => {
      // not sure why timeout is needed but without it would be getting 0 value
      this.loadData()
    }, 1000)
    this.showUploadLogo =
      window.location.host !== 'app.howuku.com' &&
      this.$customdomain().logo === 'https://cdn.howuku.com/images/logo.png' &&
      this.$isPremiumPlan.includes(this.$session.get('paid_plan'))

    let menu = localStorage.getItem('howuku_menu')
    if (menu && menu.startsWith('[')) this.displayMenu = JSON.parse(menu)
  },
  methods: {
    async trackCategory(key) {
      try {
        this.$auditlog({
          module: 'category',
          action: key,
        })
      } catch (e) {}
      try {
        _cio.track('category', {
          name: key,
          created_at: Math.round(new Date().getTime() / 1000),
        })
      } catch (e) {
        console.error(e)
      }
    },
    hoverMinimize(bool) {
      clearTimeout(this.hoverDelay)
      this.hoverDelay = setTimeout(() => {
        if (this.minimized) {
          this.showDuringMinimize = !bool
          if (bool === true)
            document.body.style.setProperty('--sidebar-width', '74px')
          else document.body.style.setProperty('--sidebar-width', '260px')
        }
      }, 10)
    },
    toogleMinimize(bool) {
      setTimeout(() => {
        this.minimized = bool
        this.showDuringMinimize = false
        if (bool === true)
          document.body.style.setProperty('--sidebar-width', '74px')
        else document.body.style.setProperty('--sidebar-width', '260px')
      }, 10)
    },
    toogleMenu(item) {
      if (this.displayMenu.includes(item)) {
        this.displayMenu = this.displayMenu.filter((a) => a !== item)
      } else {
        this.displayMenu.push(item)
      }

      localStorage.setItem('howuku_menu', JSON.stringify(this.displayMenu))
    },
    heatmapOldVersion() {
      return localStorage.getItem('heatmap_preference') === 'v1'
    },
    setAgencyName(n) {
      if (n === 'Premium' && this.$session.get('lifetimedeal')) return 'Agency'
      return n
    },
    numberToText2(n) {
      if (n === 0) return 0
      if (n >= 1000000) return parseInt(n / 1000000).toString() + 'M'
      if (n >= 1000) return parseInt(n / 1000).toString() + 'K'
      return n
    },
    numberToText(n) {
      if (n === 0) return ''
      if (n >= 1000000) return '/ ' + (n / 1000000).toString() + 'M'
      if (n >= 1000) return '/ ' + (n / 1000).toString() + 'K'
      return '/ ' + n
    },
    numberFormat(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    feature(data, value) {
      return data.includes(value)
    },
    loadData: function () {
      // this.$router.push({ path: '/dashboard' })
      let options = {
        widget_id: this.$session.get('widget_id'),
      }

      this.$http
        .get(process.env.API_ENDPOINT + '/usage', options)
        .then((response) => {
          let data = response.data
          setTimeout(() => {
            this.loading = true

            if (data[0].session && this.plan.sessions) {
              this.monthly = data[0].session
            } else {
              this.monthly = data[0].pageview
            }
          })
        })

        this.$http
        .post(process.env.API_ENDPOINT + '/getWidgetsNoCache', {
          widget_id: this.$session.get('widget_id'),
        })
        .then((response) => {
          let data = response.data
          this.$session.set('website_limit', data[0].pageview_limit)

          if (this.plan.sessions) {
            this.isSession = true

            this.planTotalLimit = this.plan.sessions + this.plan.rewarded_session
          } else this.planTotalLimit = this.plan.pageview

          this.$http.get(process.env.API_ENDPOINT + '/planInfo').then((response) => {
            let data = response.data
            this.pageviewLimit =
              this.planTotalLimit + data[0].additional_pageview
          })


          this.acl_data = data[0].feature_acl
          this.setFeaturesACL(this.acl_data)
          window.localStorage.setItem('feature_acl', data[0].feature_acl)

          this.notificationCount = this.$store.getters.notifFeedback
        })

      // this.$http
      //   .get(process.env.API_ENDPOINT + '/getCompany')
      //   .then((response) => {
      //       let result = response.data[0]
      //       this.recommendationsVal = Number(result.recommendation_add_on)
      //   })

      this.$http
        .post(process.env.API_ENDPOINT + '/requestStatus', { widgetId: this.$session.get('widget_id')})
        .then((response) => {
          let result = response.data[0]
          this.enableRecommendVal = Number(result.enable_recommend)
          this.recommendationsVal = Number(result.recommendation_add_on)
        })
      
      this.$http
        .post(process.env.API_ENDPOINT + '/totalUnreadRecommendation', {
          widget_id: this.$session.get('widget_id'),
        })
        .then((response) => {
          let result = response.data[0]
          this.totalUnreadRecomm = Number(result.total_recomm)
          console.log(this.totalUnreadRecomm)
        })
      // this.$router.push({ path: '/dashboard' })
    },
    setFeaturesACL(acl_data){
      try {
        this.feedbackVal = this.feature(acl_data, 'feedback')
        this.surveyVal = this.feature(acl_data, 'survey')
        this.recordVal = this.feature(acl_data, 'recording')
        this.heatmapVal = this.feature(acl_data, 'heatmap')
        this.eventtrackVal = this.feature(acl_data, 'eventtrack')
        this.formAnalyticVal = this.feature(acl_data, 'formanalytic')
        this.abtestVal = this.feature(acl_data, 'abtest')
        this.personalizeVal = this.feature(acl_data, 'personalize')
        this.analyticsVal = this.feature(acl_data, 'analytics')
        this.funnelVal = this.feature(acl_data, 'funnel')
        this.goalVal = this.feature(acl_data, 'goal')
        this.errortrackVal = this.feature(acl_data, 'errortrack')
      } catch(e){}
    },
    cap100(n) {
      return n < 100 ? n : 100
    },
    logout: function () {
      this.$router.push({ path: '/logout' })
    },
  },
}
</script>

<style>
/* Hide scrollbar for Chrome, Safari and Opera */

.slideDown-enter-active,
.slideDown-leave-active {
  transition: all 0.1s ease-out;
  overflow: hidden;
}
.slideDown-enter, .slideDown-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}
.slideDown-enter-to,
.slideDown-leave {
  height: 50px;
}

.bottom-container {
  /* background-color: #f6f7f9; */
  /* background-color: rgba(var(--main-color), 0.04); */
  border-radius: 8px;
  padding: 0px 6px;
  box-shadow: 0 6px 6px 0 rgb(0 0 0 / 3%), 0 1px 2px 0 rgb(0 0 0 / 4%);
}

.show-enter-active,
.show-leave-enter {
  /* transform: translateX(0); */
  transition: width 1s linear;
}
.show-enter,
.show-leave-to {
  /* transform: translateX(100%); */
}
</style>



// WEBPACK FOOTER //
// src/layouts/menus/SideMenu.vue